// M4-A3 — Intercetta link esterni nel runtime Capacitor e li apre nel browser/app di sistema.
// Additivo e conservativo: web (tricomas.it in browser) totalmente invariato.
// Criterio esplicito con whitelist interna. Nessun open redirect, nessuno scheme arbitrario.
let _registered = false;

// Host interni che restano IN-APP (WebView). tricomas.it + subdomini + host del backend.
const INTERNAL_HOST_SUFFIXES = ["tricomas.it"];
try {
  const backend = process.env.REACT_APP_BACKEND_URL;
  if (backend) {
    const h = new URL(backend).hostname;
    if (h) INTERNAL_HOST_SUFFIXES.push(h);
  }
} catch (e) { /* URL backend non parsabile: ignora */ }

function isInternalHost(hostname) {
  const host = (hostname || "").toLowerCase();
  return INTERNAL_HOST_SUFFIXES.some(
    (suffix) => host === suffix || host.endsWith("." + suffix),
  );
}

// Scheme che apriamo esplicitamente tramite app di sistema (dialer/email). Whitelist chiusa.
const SYSTEM_SCHEMES = new Set(["tel:", "mailto:", "sms:"]);

function findAnchor(target) {
  let el = target;
  while (el && el !== document.body) {
    if (el.tagName === "A" && el.getAttribute("href")) return el;
    el = el.parentElement;
  }
  return null;
}

async function openInSystemBrowser(url) {
  try {
    const { Browser } = await import("@capacitor/browser");
    await Browser.open({ url });
  } catch (e) {
    // Fallback conservativo: apertura di sistema. Nessun secret nei log.
    window.open(url, "_blank");
  }
}

export async function initMobileExternalLinks() {
  const Cap = window.Capacitor;
  if (!Cap || typeof Cap.isNativePlatform !== "function" || !Cap.isNativePlatform()) return;
  if (_registered) return; // nessun doppio listener
  _registered = true;

  document.addEventListener(
    "click",
    (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const anchor = findAnchor(event.target);
      if (!anchor) return;

      const rawHref = anchor.getAttribute("href");
      if (!rawHref || rawHref.startsWith("#")) return;

      let parsed;
      try {
        parsed = new URL(rawHref, window.location.href);
      } catch (e) {
        return; // href non parsabile: non tocchiamo
      }

      const protocol = parsed.protocol; // es. "https:", "tel:", "mailto:"

      // Scheme di sistema noti (tel/mailto/sms) -> app dedicata.
      if (SYSTEM_SCHEMES.has(protocol)) {
        event.preventDefault();
        window.open(parsed.href, "_system");
        return;
      }

      // http/https: interni restano in-app, esterni al system browser.
      if (protocol === "http:" || protocol === "https:") {
        if (isInternalHost(parsed.hostname)) {
          // Link interno tricomas.it/backend -> naviga normalmente nella WebView.
          // (Stripe Checkout non viene intercettato: sara' gestito in M4-A5.)
          return;
        }
        event.preventDefault();
        openInSystemBrowser(parsed.href);
        return;
      }

      // Qualsiasi altro scheme non riconosciuto -> ignorato (nessun open arbitrario).
    },
    true, // fase capture
  );
}
